export default "__VITE_ASSET__CFlzWne8__"